import { render, staticRenderFns } from "./storeDictionaryEdit.vue?vue&type=template&id=4470ada5&scoped=true&"
import script from "./storeDictionaryEdit.vue?vue&type=script&lang=js&"
export * from "./storeDictionaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./storeDictionaryEdit.vue?vue&type=style&index=0&id=4470ada5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470ada5",
  null
  
)

component.options.__file = "storeDictionaryEdit.vue"
export default component.exports